var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import CardProfile from '../../../../components/Card/Profile';
import { Musicalite } from '../../../../components/CustomIcon';
import { useValidation } from '../../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useUser } from '../../../../hooks/useUser';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import { useOutletContext } from 'react-router-dom';
import MultiSelectFull from '../../../../components/Fields/MultiSelect/Full';
import { deepEqual, pick } from '../../../../utils/Objects';
import { serialize } from 'object-to-formdata';
import { toast } from 'react-toastify';
var DashboardPublicMusicalGenres = function () {
    var _a = useOutletContext(), user = _a.user, handleUser = _a.handleUser, handleFormError = _a.handleFormError;
    var isDone = useUser().isDone;
    var arrayNullable = useValidation().arrayNullable;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), categories = _c[0], setCategories = _c[1];
    var _d = useState(false), drawer = _d[0], setDrawer = _d[1];
    var max = 8;
    var schema = yup.object().shape({
        musical_genres: arrayNullable,
        custom_musical_genres: arrayNullable,
        sorted_musical_genres: arrayNullable,
    });
    var _e = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            musical_genres: user.musical_genres,
            custom_musical_genres: user.custom_musical_genres,
            sorted_musical_genres: user.sorted_musical_genres,
        },
    }), handleSubmit = _e.handleSubmit, control = _e.control, reset = _e.reset, watch = _e.watch, setValue = _e.setValue;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (deepEqual(data, pick(user, ['musical_genres', 'custom_musical_genres', 'sorted_musical_genres'])))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(data, { indices: true, allowEmptyArrays: true });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    reset(pick(response.data, ['musical_genres', 'custom_musical_genres', 'sorted_musical_genres']));
                    toast.success('Vos genres musicaux ont bien été mis à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleFormError(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    setDrawer(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        axiosInstance.get(api.musicalGenres.categories).then(function (_a) {
            var data = _a.data;
            setCategories(data);
        });
    }, []);
    return (<form onSubmit={handleSubmit(onSubmit)}>
      <CardProfile title="Mes genres musicaux" description="Spécialiste d'un genre musical ? Dans votre domaine d'activité ou de création ? Soul, Jazz, Pop, Classique... Affichez vos couleurs." icon={Musicalite} filled={isDone('musical_genres') || isDone('custom_musical_genres')} onClick={function () {
            setDrawer(true);
        }}/>

      <MultiSelectFull name="musical_genres" control={control} categories={categories} title="Genres musicaux" description={"Spécialiste d'un genre musical ? Dans votre domaine d'activité ou de création ? Soul, Jazz, Pop, Classique... Affichez vos couleurs. \nConsultez et réorganisez votre sélection en cliquant sur l'icone à droite de la barre de recherche ci-dessous."} max={max} open={drawer} handleClose={function () { return setDrawer(false); }} submit loading={loading} noResults="Vos genres musicaux apparaîtront ici" custom={watch('custom_musical_genres')} handleCustom={function (value) {
            return setValue('custom_musical_genres', value);
        }} sorted={watch('sorted_musical_genres')} handleSorted={function (value) {
            return setValue('sorted_musical_genres', value);
        }} noResultsCustom="Ce genre musical n'est pas encore disponible sur Majeur·e·s" sortingIndicationText="Réorganisez facilement votre liste de genres musicaux selon vos préférences grâce à la fonctionnalité de glisser-déposer !" addCustomText="Ajouter le genre musical"/>
    </form>);
};
export default DashboardPublicMusicalGenres;
